import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    projects: [],
    keyword: ""
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setInitialValue: (state, action) => {
            state.projects = action.payload
        },
        filterByProject: (state, action) => {
            if (state.projects.includes(action.payload)) {
                // remove project from array
                state.projects = state.projects.filter(project => project !== action.payload)
            } else {
                // add project
                state.projects.push(action.payload)
            }
        },
        searchTask: (state, action) => {
            state.keyword = action.payload.toLowerCase()
        }
    },
});

export const { setInitialValue, filterByProject, searchTask } = filterSlice.actions;
export default filterSlice.reducer;
